import React, { Component } from 'react'
import axios from "axios";
import { APIURL } from '../../components/constants/common';
import genhavenColor1 from '../../assets/images/genhaven-color1.webp'
import logo_color from '../../assets/images/genhaven-color.webp'
import AML from '../../assets/images/AML.png'
import AXA from '../../assets/images/AXA-insurance-Logo.png'
import PRS from '../../assets/images/PRS_Logo_high.png'
import {ReactComponent as Facebook} from '../../assets/images/facebook.svg'
import {ReactComponent as Linkedin} from '../../assets/images/linkedin.svg'
import {ReactComponent as Instagram} from '../../assets/images/instagram.svg'
import {ReactComponent as Twitter} from '../../assets/images/twitter.svg'
import { Link } from 'react-router-dom'

     
export default class Footer extends Component {
	constructor(props){
		super(props);
		this.state = {
			token: JSON.parse(localStorage.getItem("token")),
			user: JSON.parse(localStorage.getItem("userData")),
			isLoggedin: localStorage.getItem("isLoggedIn"),
			category_list:[]
		}
	}
	
	componentDidMount(){
        this.getCategory()
	}

	getCategory(){
		const formData = new FormData();
		var token = this.state.token
		axios
			.post(APIURL + "get-category-list", formData, {
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			.then((response) => {
				this.setState({
					category_list: response.data.data,  
				})
			})
			.catch((error) => {
				this.setState({
					errMsg: error.response.data.errors,
					Loader: false
				})
			});
   	}

    render() {
        return (
            <div>
                <footer>
				<div class="container">
					<div class="row mt-5"> 
						<div class="col-lg-3 col-md-4">
							<div class="footer-logo">
								<a href="#"><img loading="lazy" src={genhavenColor1} alt="genhaven Logo" /></a>
							</div>
							<div class="mt-4">
								<ul class="footer_link">
									<li><strong>Address:</strong> Titan House, Titan Road, Cardiff Wales, United Kingdom CF24 5BS</li>
									<li><a href="tel:+447879146191"><strong>Phone:</strong> +44(0) 7879146191</a></li>
									<li><a href="mailto:office@genhaven.co.uk"><strong>Email:</strong> office@genhaven.co.uk</a></li> 
								</ul>
								<div className='d-flex align-items-center flex-wrap my-3'>
									<img className='me-2 mb-2' loading="lazy" src={AML} />
									<img className='me-2 mb-2' loading="lazy" src={AXA} />
									<img loading="lazy" className='mb-2' src={PRS} />
								</div>
							</div>
						</div>  

						<div class="col-lg-9 col-md-8">
							<div class="row">
								<div class="col-lg-3 col-sm-6">
									<h4>Navigations</h4>
									<div class="mt-4">
										<ul class="footer_link ">
											<li><Link to="/page/about-us">About Us</Link></li>
											{/* <li><a href="#">FAQs Page</a></li> */}
											<li><Link to="/contact-us">Contact</Link></li>
											<li><Link to="/page/terms-condition">Terms of Use</Link></li>
											<li><Link to="/page/privacy-policy">Privacy Policy</Link></li>
											<li><Link to="/page/cookies-policy">Cookies Policy</Link></li>
										</ul>
									</div>
								</div>

								<div class="col-lg-3 col-sm-6">
									<h4>The Highlights</h4>
									<div class="mt-4">
										<ul class="footer_link">
											{ this.state.category_list.length > 0 && this.state.category_list.map((item, index) => (
												<li><a href={"/search?category="+item.id}>{item.category_name}</a></li>
												// to={}
											))}
										</ul>
									</div>
								</div>

								<div class="col-lg-3 col-sm-6">
									<h4>My Account</h4>
									<div class="social mt-4">
										<ul class="footer_link">
											{ this.state.user!=null && this.state.user.user_type=="Buyer" &&
												<li><Link to="/buyer">My Profile</Link></li>
											}
											{ this.state.user!=null && this.state.user.user_type=="Seller" &&
												<li><Link to="/seller">My Profile</Link></li>
											}
											{ this.state.user!=null && this.state.user.user_type=="Agent" &&
												<li><Link to="/agent">My Profile</Link></li>
											}
											{ this.state.user!=null && this.state.user.user_type=="Admin" &&
												<li><Link to="/admin">My Profile</Link></li>
											}
											{ this.state.user === null && this.state.isLoggedin === false &&
												<li><Link to="/signin">My Profile</Link></li>
											}
											<li><Link to="/search">Find Property</Link></li>
											{ this.state.user!=null && this.state.user.user_type=="Buyer" &&
												<li><Link to="/buyer/wishlist">Favorites</Link></li>
											}
											{ this.state.user === null && this.state.isLoggedin === false &&
												<li><Link to="/signin">Favorites</Link></li>
											}
										</ul>
									</div>
								</div>

								<div class="col-lg-3 col-sm-6">
									<h4>Connect</h4>
									<div class="social mt-4">
										<ul>						        
											<li><a target="_blank" href="https://www.facebook.com/genhaventrades">
												<Facebook class="img-svg" alt="user" /> <span>Facebook</span> 
											</a></li>
											<li><a target="_blank" href="https://twitter.com/genhaventrades">
												<Twitter class="img-svg" alt="user" /> <span>Twitter</span> 
											</a></li>
											<li><a target="_blank" href="https://www.instagram.com/genhaventrades/">
												<Instagram class="img-svg" alt="user" /> <span>Instagram</span>
											</a></li>
										</ul>
									</div>
								</div>	
							</div>	
						</div>	
					</div>
				</div>
				<div class="copyright">		
					<div class="container">
						<div class="row">
							<div class="col-sm-6">© 2021 Genhaven Realestate. All Rights Reserved</div>
							<div class="col-sm-6 text-right"><a href="#">Privacy Policy</a> | <a href="#">Sales Conditions</a></div>
						</div>
					</div>
				</div>
			</footer>
            </div>
        )
    }
}
